export default __webpack_public_path__ + "static/media/04AW3NOV65.43a784a6.jpg";